import type { SerializedAuthUser } from "./utils";

/**
 * The refresh handoff is a synchronous, cross-tab-coherent signal used to make
 * the single-use refresh token safe across multiple tabs.
 *
 * Whichever tab performs a refresh writes the fresh token here BEFORE releasing
 * the cross-tab lock (see `acquireRefresh`). A tab that acquires the lock right
 * after can then adopt the fresh token instead of re-POSTing the already-consumed
 * one — its own redux store is only updated later via the async broadcast channel,
 * so localStorage is the reliable happens-before channel here.
 *
 * Namespaced so it is clearly an auth mechanism key, kept separate from the
 * feature-flag-style entries in `LOCAL_STORAGE_KEYS`.
 */
export const REFRESH_TOKEN_HANDOFF_KEY = "volt:auth:refresh-token-handoff";

export function readHandoff(): SerializedAuthUser | null {
  try {
    const raw = localStorage.getItem(REFRESH_TOKEN_HANDOFF_KEY);

    if (!raw) {
      return null;
    }

    return JSON.parse(raw) as SerializedAuthUser;
  } catch {
    return null;
  }
}

export function writeHandoff(tokenData: SerializedAuthUser) {
  localStorage.setItem(REFRESH_TOKEN_HANDOFF_KEY, JSON.stringify(tokenData));
}

export function clearHandoff() {
  localStorage.removeItem(REFRESH_TOKEN_HANDOFF_KEY);
}
